// extracted by mini-css-extract-plugin
export default {"sharedTable":"party-master_sharedTable__c-ZSd"};